export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/array.js
// module id = Iv00
// module chunks = 0